import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_pressure",
  "use": "icon-icon_pressure-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-icon_pressure\"><path d=\"M16.545 4C19.558 4 22 6.332 22 9.208c0 2.877-2.608 7.891-9.997 11.292C4.739 17.038 2 12.085 2 9.208 2 6.332 4.442 4 7.455 4c1.898 0 3.57.927 4.548 2.332C12.974 4.927 14.647 4 16.545 4Z\" fill=\"#F5222D\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol